module.exports = __webpack_public_path__ + "static/media/usn-6.836ebeb1.jpg";